import { Stats } from './stats.js';
//
// Rename to sample?
// Split notify-functionality out?  Via a decorator, or containment?
//
export class Dataset {
    constructor(notifyObservers, values) {
        this.counter = 0;
        this.notifyObservers = undefined;
        this.data = [];
        this.notifyObservers = notifyObservers;
        this.data = values.map(n => this.createRecord(n));
    }
    createRecord(value) {
        this.counter += 1;
        return {
            key: this.counter,
            value: value
        };
    }
    // used for 'add' as well
    update(index, value) {
        this.data[index] = this.createRecord(value);
        this.notify();
    }
    remove(index) {
        this.data.splice(index, 1);
        this.notify();
    }
    notify() {
        if (this.notifyObservers !== undefined) {
            this.notifyObservers([...this.data]);
        }
    }
    reset(values) {
        this.counter = 1;
        this.data = values.map(n => this.createRecord(n));
        this.notify();
    }
    stats() {
        return new Stats(this.data.map(x => x.value));
    }
}
//# sourceMappingURL=dataset.js.map